import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <React.Fragment>
      <section className="privacy_banner">
        <div className="wrapper">
          <h1 className="usable_title">Terms and Conditions</h1>
          <span className="lastUpdate">
            Effective Date: <b>1st Jan 2024</b>
          </span>
          <p className="para_common">
          Welcome to LOADINN! These Customer Terms and Conditions ('Terms') govern your use of the LOADINN platform ('Platform'), operated by [Your Company Name] ('we,' 'us,' or 'our'). By accessing or using our services, you agree to these Terms.

          </p>
        </div>
      </section>
      <section>
  <div className="wrapper">
    <div className="privacy_content">
      
      <h2>1. Introduction</h2>
      <p>
        By using this website, you agree to comply with and be bound by the following terms of use. These terms govern LoadInn's relationship with you regarding this website and services provided.
      </p>

      <h2>2. Account Registration & Management</h2>
      <ul>
        <li>Customers must create an account and log in to place an order.</li>
        <li>The following details are required for registration:
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
          </ul>
        </li>
        <li>Customers can delete their accounts at any time through the 'Delete Account' tab in settings.</li>
        <li>Customers may create a new account after deletion, as we do not suspend accounts.</li>
      </ul>

      <h2>3. Orders & Payments</h2>
      <ul>
        <li>Payments must be made via:
          <ul>
            <li>Credit/Debit Card</li>
            <li>Apple Pay</li>
            <li>Google Pay</li>
          </ul>
          <em>Cash on delivery is not available.</em>
        </li>
        <li>Customers can cancel orders, but refunds are subject to our Refund Policy.</li>
        <li>If a restaurant rejects an order, the customer receives a full refund.</li>
        <li>If a restaurant accepts an order but later denies it, the customer is refunded, and the amount is deducted from the restaurant’s payout.</li>
        <li>If a courier rejects an order, another courier will be assigned. If a courier accepts an order but later denies it, another courier will be assigned.</li>
        <li>If an issue arises after a courier has picked up the order, we will attempt to arrange delivery. If that fails, a refund will be processed by LOADINN.</li>
        <li>Delivery Fees vary based on demand. Standard pricing:
          <ul>
            <li>€2.76 for the first 2 km</li>
            <li>€0.61 per km beyond 2 km</li>
          </ul>
        </li>
      </ul>

      <h2>4. Refunds & Disputes</h2>
      <ul>
        <li>Refund policies are outlined in our Refund Policy.</li>
        <li>Customers must report any order issues via our Chat Support within 12 hours from the time the order was placed.</li>
        <li>Refund eligibility is determined by LOADINN based on the reported issue.</li>
        <li>If an order cannot be delivered due to a mistake on our end, a full refund will be provided (as per our Refund Policy).</li>
        <li>If the issue is caused by the customer’s mistake (e.g., incorrect address, unavailable at the delivery time), no refund will be provided.</li>
      </ul>

      <h2>5. Delivery & Responsibilities</h2>
      <ul>
        <li>Estimated delivery times depend on restaurants, couriers, traffic, and other factors. No guaranteed delivery time is provided.</li>
        <li>If the customer provides an incorrect address or is unavailable to receive the order, no refund will be given.</li>
        <li>If the restaurant or courier makes an error, LOADINN will process refunds as per the Refund Policy.</li>
        <li>Customers can track their orders in real-time through the Platform.</li>
      </ul>

      <h2>6. Liability & Disclaimers</h2>
      <ul>
        <li>Restaurants are fully responsible for food quality, preparation, and safety. LOADINN is only a platform that facilitates the ordering and delivery process.</li>
        <li>Customers with food allergies or dietary restrictions must check with the restaurant before placing an order. LOADINN is not responsible for any allergic reactions or dietary issues.</li>
        <li>LOADINN is not liable for delays due to traffic, weather, or restaurant delays.</li>
        <li>Future insurance coverage for deliveries may be introduced, but as of now, it is not available.</li>
      </ul>

      <h2>7. Account Suspension & Termination</h2>
      <ul>
        <li>Currently, LOADINN does not suspend or terminate customer accounts.</li>
        <li>Customers can delete their accounts anytime and create a new account later if they wish.</li>
      </ul>

      <h2>8. Governing Law & Dispute Resolution</h2>
      <ul>
        <li>These Terms are governed by Latvian law.</li>
        <li>Customers can raise concerns and disputes via our Chat Support for direct resolution.</li>
      </ul>

      <h2>9. Changes to Terms</h2>
      <p>We reserve the right to update these Terms at any time. Any changes will be posted on our website and will take effect immediately upon posting.</p>

      <p>By using LOADINN, you acknowledge that you have read and agree to these Terms.</p>

      <h2>10. Contact Us</h2>
      <ul>
        <li>For any questions, contact us via Chat Support on our platform.</li>
      </ul>

    </div>
  </div>
</section>

    </React.Fragment>
  );
};

export default Terms;
